import React from 'react';
import { Award, Globe, Users } from 'lucide-react';

const OurPilots = () => {
  const qualities = [
    {
      icon: <Award className="w-16 h-16" style={{ color: '#EE6A1F' }} />,
      title: 'Experience',
      description: 'Our team of international pilots have a combined experience of thousands of hours flying hot air balloons commercially all over the world.'
    },
    {
      icon: <Users className="w-16 h-16" style={{ color: '#EE6A1F' }} />,
      title: 'Pilot Skill',
      description: 'Each pilot is highly trained and certified by the Kenyan Civil Aviation Authority, with extensive knowledge of Uganda terrain and wildlife patterns.'
    },
    {
      icon: <Globe className="w-16 h-16" style={{ color: '#EE6A1F' }} />,
      title: 'Languages',
      description: 'Our international team speaks multiple languages including English, French, German, and Italian, ensuring clear communication with all guests.'
    }
  ];

  return (
    <div className="min-h-screen pt-20">
      <section
        className="relative h-96 flex items-center justify-center text-white"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1572795508320-64924203e9f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxob3QlMjBhaXIlMjBiYWxsb29uJTIwc2FmYXJpfGVufDB8fHx8MTc2MzA3MTA4OHww&ixlib=rb-4.1.0&q=85)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="relative z-10 text-center px-4">
          <h1 className="text-5xl md:text-6xl font-bold">Our Pilots</h1>
          <p className="text-xl mt-4">Expert aviators with a passion for Africa</p>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-gray-800 mb-8">WHY CHOOSE US?</h2>
          <p className="text-xl text-gray-700 leading-relaxed mb-12">
            Our pilots are the heart of SKYHIGH Adventures. With decades of combined experience and an unwavering commitment to safety and excellence, they bring the magic of Uganda to life from above.
          </p>
        </div>
      </section>

      <section className="py-12 px-4 bg-stone-50">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {qualities.map((quality, index) => (
              <div key={index} className="text-center">
                <div className="flex justify-center mb-6">{quality.icon}</div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4">{quality.title}</h3>
                <p className="text-gray-600 leading-relaxed">{quality.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://images.unsplash.com/photo-1633824827560-6e60955a571d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxob3QlMjBhaXIlMjBiYWxsb29uJTIwc2FmYXJpfGVufDB8fHx8MTc2MzA3MTA4OHww&ixlib=rb-4.1.0&q=85"
                alt="Pilot expertise"
                className="rounded-lg shadow-xl"
              />
            </div>
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Safety & Expertise</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Safety is at the heart of everything we do. Our pilots undergo rigorous annual inspections by the Kenyan Civil Aviation Authority (KCAA) and maintain the highest standards of professional ballooning.
              </p>
              <p className="text-gray-700 leading-relaxed">
                This combination of international experience and local expertise ensures that every flight is not only safe but also unforgettable.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 px-4 text-white text-center" style={{ backgroundColor: '#EE6A1F' }}>
        <div className="max-w-4xl mx-auto">
          <blockquote className="text-2xl italic mb-6">
            "The pilot's knowledge of the area and wildlife was incredible. Made the experience so much richer!"
          </blockquote>
          <p className="text-lg">– Verified Guest Review 2024</p>
        </div>
      </section>
    </div>
  );
};

export default OurPilots;
